/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request body fields required and optional to operate on Order Approval Permission Type data. Typical permission types are: B2BBudgetExceededPermission, B2BOrderThresholdTimespanPermission and B2BOrderThresholdPermission
 * @export
 * @interface OrderApprovalPermissionType
 */
export interface OrderApprovalPermissionType {
    /**
     * Code of the Order Approval Permission Type
     * @type {string}
     * @memberof OrderApprovalPermissionType
     */
    code: string;
    /**
     * Name of the Order Approval Permission Type
     * @type {string}
     * @memberof OrderApprovalPermissionType
     */
    name?: string;
}

/**
 * Check if a given object implements the OrderApprovalPermissionType interface.
 */
export function instanceOfOrderApprovalPermissionType(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function OrderApprovalPermissionTypeFromJSON(json: any): OrderApprovalPermissionType {
    return OrderApprovalPermissionTypeFromJSONTyped(json, false);
}

export function OrderApprovalPermissionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderApprovalPermissionType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function OrderApprovalPermissionTypeToJSON(value?: OrderApprovalPermissionType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
    };
}

